export * from "./atoms";
export * from "./molecules";

import { StatusAtoms } from "./atoms";
import { StatusMolecules } from "./molecules";

export const StatusComponents = [...StatusAtoms, StatusMolecules];
